//3rd Party Components
import React, { Fragment } from 'react';
import moment from 'moment';
import axios from 'axios';
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom";
import { AUcallout } from '@gov.au/callout';
import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

//Components
import Heading from '../components/CASA/Heading';
import SortedTable from '../components/Portal/SortedTable';
import CASASpinner from '../components/Portal/CASASpinner';
import Container from '../components/CASA/Container';

//Actions
import { getUserHomePage, UserMustVerifyPOI, UserMustSubmitIndividualARNApplication, getPortalUrl } from '../components/Portal/Utilities';
import { getUrlSelector, getSnippetSelector, getFeatureSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getAircraftIndividual, FETCH_AIRCRAFTINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/AircraftIndividualActions';
import { getAircraftTOOIndividual, FETCH_AIRCRAFTTOOINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/AircraftTOOIndividualActions';
import { getAppsIndividual, FETCH_APPSINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/AppsIndividualActions';
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';

export const ManageAircraftIndPage = () => {

    let history = useHistory();
    let dispatch = useDispatch();

    const [pageLoading, setPageLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [pageLoadedError, setPageLoadedError] = useState(false);
    const [pageLoadedErrorMessage, setPageLoadedErrorMessage] = useState("");
    const [allowDownload, setAllowDownload] = useState(false);

    let userdetails = useSelector(state => state.userdetails);
    let B2CSettings = useSelector(state => state.B2CSettings);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);
    let appsIndividual = useSelector(state => state.appsIndividual);

    let aircraftIndividual = useSelector(state => state.aircraftIndividual);
    let aircraftIndividualTOO = useSelector(state => state.aircraftIndividualTOO);

    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));

    let ACRStartDate = useSelector(state => getFeatureSelector(state, "Portal - ACR Start Date"));
    let ACREndDate = useSelector(state => getFeatureSelector(state, "Portal - ACR End Date"));

    let draftARNs = useSelector(state => state.draftsIndividual.items.draftARNs);

    let snippetARC = useSelector(state => getSnippetSelector(state, "CASA - Aircraft Registration Confirmation"));
    let snippetGliderNR = useSelector(state => getSnippetSelector(state, "CASA - Glider Confirmation Not Required"));

    let pageAlert = useSelector(state => state.pageAlert);

    if (!pageLoaded && pageAlert.level !== "") {
        dispatch(addPageAlert({ level: "", title: "", message: "" }));
    }

    useEffect(() => {

        const webappurl = B2CSettings.items.webappurlPortalApi;
        const accessToken = B2CSettings.items.accesstokenPortal;
        const webappurlF = B2CSettings.items.webappurlFormsApi;

        setPageLoading(true);

        axios.all([
            dispatch(getAircraftIndividual(webappurlF, accessToken)),
            dispatch(getAircraftTOOIndividual(webappurl, accessToken)),
            dispatch(getAppsIndividual(webappurl, accessToken))
        ])
            .then(axios.spread((aircraftres, aircraftTOOres, appsindres) => {
                if (aircraftres.type === FETCH_AIRCRAFTINDIVIDUAL_SUCCESS 
                    && aircraftTOOres.type === FETCH_AIRCRAFTTOOINDIVIDUAL_SUCCESS 
                    && appsindres.type === FETCH_APPSINDIVIDUAL_SUCCESS
                ) {
                    setPageLoaded(true);
                    setPageLoading(false);
                }
                else {
                    setPageLoadedError(true);
                    setPageLoadedErrorMessage("MAI.1");
                    setPageLoading(false);
                    setPageLoaded(true);

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: MAI.1";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            }))
            .catch(function (error) {
                setPageLoadedError(true);
                setPageLoadedErrorMessage("MAI.2");
                setPageLoading(false);
                setPageLoaded(true);

                let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                let details = "Details: MAI.2";
                dispatch(addPageAlert({ level: "error", title: msg, message: details }));
            });

    }, []);

    const manageAcft = (selectedAcft) => {
        history.push("/singleaircraftind?standalone=" + standalone + "&aircraft=" + encodeURIComponent(btoa(JSON.stringify(selectedAcft))) );
    };

    const populateAircraftTOOInfo = (aircraft, params) => {
        let sellerid, buyerid, roid;

        aircraft.msgToo = 'Transfer in progress';
        aircraft.msglevel = 'info';
        aircraft.submissionid = params.submissionid;

        if (params.srvcatjob == 'ACR_TOO_INIT') {
            sellerid = params.contactId;
            if (sellerid == params.userId) {
                aircraft.isSeller = true;
            }
        }
        else if (params.srvcatjob == 'ACR_TOO_REV') {
            buyerid = params.contactId;
            if (buyerid == params.userId) {
                aircraft.isBuyer = true;
            }
        }
        else if (params.srvcatjob == 'ACR_TOO_ACC') {
            roid = params.contactId;
            if (roid == params.userId) {
                aircraft.isRO = true;
            }
        }
        else if (params.srvcatjob == 'ACR_TOO_COM') {
            buyerid = params.contactId;
            if (buyerid == params.userId) {
                aircraft.isBuyer = true;
            }
        }
    }

    const styleCellGlider = (row, col) => {
        if (col.property === "vhmark") {
            var cellStyle = {
                fontWeight: 'normal'
            };
            return cellStyle;
        }
    }

    let aircraftCols = [
        {
            "label": "VH-Mark",
            "property": "vhmark",
            "visible": true,
            "type": "string",
            "width": "20%",
            "command": null,
            "commandLink": manageAcft
        },
        {
            "label": "Manufacturer and model",
            "property": "name",
            "visible": true,
            "hasMsg": "msgToo",
            "hasMsglevel": "msglevel",
            "type": "string",
            "width": "30%"
        },
        {
            "label": "Registered operator details",
            "property": "operator",
            "visible": true,
            "type": "string",
            "width": "50%"
        }
    ];

    let gliderCols = [
        {
            "label": "VH-Mark",
            "property": "vhmark",
            "visible": true,
            "type": "string",
            "width": "20%",
            "command": null,
            "commandLink": null
        },
        {
            "label": "Manufacturer and model",
            "property": "casa_name",
            "visible": true,
            "hasMsg": "msgToo",
            "hasMsglevel": "msglevel",
            "type": "string",
            "width": "30%"
        },
        {
            "label": "Registered operator details",
            "property": "owner",
            "visible": true,
            "type": "string",
            "width": "50%"
        }
    ];

    const setInnerHTML = (value) => {
        return { __html: value };
    };

    // prevent access if user does not have arn or has not applied for one
    let userHomePage = getUserHomePage(srarnsIndividual, draftARNs, userdetails, tagsIndividual, acceptedSRsIndividual, participants);
    if (UserMustSubmitIndividualARNApplication(userHomePage) || UserMustVerifyPOI(userHomePage)) {
        history.push(userHomePage);
        return null;
    }
    else {
        if (!pageLoaded) {
            return (
                <Fragment>
                    <MetaTags>
                        <title>Manage Aircraft (Individual)</title>
                    </MetaTags>

                    <Container show={true}>

                        <CASASpinner message="Working. Please wait....." />

                    </Container>

                </Fragment>
            )
        }
        else {
            const loc = getPortalUrl("/dashind", standalone, urlHome);

            let items = [
                {
                    link: loc,
                    text: 'myCASA'
                },
                {
                    text: 'Manage aircraft'
                },
            ];
            let showItems = true;

            let aircraftArr = [];
            let gliderArr = [];

            if (aircraftIndividual && aircraftIndividual.items && ((aircraftIndividual.items.aircraft && aircraftIndividual.items.aircraft.value) || (aircraftIndividual.items.gliders && aircraftIndividual.items.gliders.value))) {
                let tomorrow = moment().add(1, 'days');
                let today = moment().startOf('day');
                for (let l = 0; l < aircraftIndividual.items.aircraft.value.length; l++) {
                    let aircraft = aircraftIndividual.items.aircraft.value[l];
                    let activeto = moment(aircraft["participant.casa_validuntil"], 'YYYY-MM-DD').startOf('day');
                    let activefrom = moment(aircraft["participant.casa_validfrom"], 'YYYY-MM-DD').startOf('day');

                    if ((activeto.isValid() === false || activeto > today)
                        && (activefrom.isValid() === false || activefrom < tomorrow)) {
                        let name = aircraft["manufacturer.casa_name"] + " " + aircraft["category.casa_name"];
                        let owner = aircraft.mainOwner["fullname"] ? aircraft.mainOwner["fullname"].toUpperCase() + " " + aircraft.mainOwner["postalAddress"] : "";
                        let operator = aircraft.mainOperator["fullname"] ? aircraft.mainOperator["fullname"].toUpperCase() + " " + aircraft.mainOperator["postalAddress"] : "";

                        let aircraftItem = {};
                        aircraftItem.name = name;
                        aircraftItem.category = aircraft["category.casa_name"];
                        aircraftItem.owner = owner;
                        aircraftItem.operator = operator;
                        aircraftItem.manufacturer = aircraft["manufacturer.casa_name"];
                        aircraftItem.model = aircraft["casa_name"];
                        aircraftItem.validuntil = aircraft["participant.casa_validuntil"];
                        aircraftItem.validfrom = aircraft["participant.casa_validfrom"];
                        aircraftItem.expiry_warning = '';
                        aircraftItem.vhmark = aircraft["aircraft.casa_registrationmark"];
                        aircraftItem.serialno = aircraft["casa_serialnumber"];
                        aircraftItem.id = aircraft["aircraft.casa_aircraftregistrationid"];
                        aircraftItem.msgExpiry = '';
                        aircraftItem.msgExpiryLevel = '';
                        aircraftItem.activeto = "";
                        if (activeto.isValid()) aircraftItem.activeto = activeto.format("DD MMM YYYY");

                        aircraftItem.numberOfEngines = aircraft["numberOfEngines"];
                        aircraftItem.yearOfManufacture = aircraft["yearOfManufacture"];
                        aircraftItem.initially = moment(aircraft["initialDate"], "YYYY-MM-DD").format("DD MMM YYYY");

                        aircraftItem.mainOwner = {};
                        aircraftItem.mainOwner.commencementDate = moment(aircraft.mainOwner["commencementDate"], "YYYY-MM-DD").format("DD MMM YYYY");
                        aircraftItem.mainOwner.fullname = aircraft.mainOwner["fullname"];
                        aircraftItem.mainOwner.postalAddress = aircraft.mainOwner["postalAddress"];
                        
                        let phone = "";
                        if (aircraft.mainOwner["telephone1"]) {
                            phone = aircraft.mainOwner["telephone1"];
                        }
                        else {
                            if (aircraft.mainOwner["mobilephone"]) {
                                phone = aircraft.mainOwner["mobilephone"];
                            }
                        }
                        aircraftItem.mainOwner.phone = phone;
                        aircraftItem.mainOwner.email = aircraft.mainOwner["emailaddress1"];                       

                        aircraftItem.mainOperator = {};
                        aircraftItem.mainOperator.commencementDate = moment(aircraft.mainOperator["commencementDate"], "YYYY-MM-DD").format("DD MMM YYYY");
                        aircraftItem.mainOperator.fullname = aircraft.mainOperator["fullname"];
                        aircraftItem.mainOperator.postalAddress = aircraft.mainOperator["postalAddress"];

                        phone = "";
                        if (aircraft.mainOperator["telephone1"]) {
                            phone = aircraft.mainOperator["telephone1"];
                        }
                        else {
                            if (aircraft.mainOperator["mobilephone"]) {
                                phone = aircraft.mainOperator["mobilephone"];
                            }
                        }
                        aircraftItem.mainOperator.phone = phone;
                        aircraftItem.mainOperator.email = aircraft.mainOperator["emailaddress1"];
                        aircraftItem.isSeller = false;
                        aircraftItem.isBuyer = false;
                        aircraftItem.isRO = false;

                        //part owner
                        if (aircraft.partOwner) {
                            aircraftItem.partOwner = {};
                            aircraftItem.partOwner.commencementDate = moment(aircraft.partOwner["commencementDate"], "YYYY-MM-DD").format("DD MMM YYYY");
                            aircraftItem.partOwner.fullname = aircraft.partOwner["name"];
                            aircraftItem.partOwner.postalAddress = aircraft.partOwner["postalAddress"];

                            phone = "";
                            if (aircraft.partOwner["telephone1"]) {
                                phone = aircraft.partOwner["telephone1"];
                            }
                            else {
                                if (aircraft.partOwner["mobilephone"]) {
                                    phone = aircraft.partOwner["mobilephone"];
                                }
                            }
                            aircraftItem.partOwner.phone = phone;
                            aircraftItem.partOwner.email = aircraft.partOwner["emailaddress1"];                            
                        }

                        for (let b = 0; b < aircraftIndividualTOO; b++) {
                            let aircraftTOO = aircraftIndividualTOO[b];
                            if (aircraftTOO["aircraft.casa_aircraftregistrationid"] === aircraft["aircraft.casa_aircraftregistrationid"] && aircraftTOO["sub.statecode"].Value == "0") { //only active in transfer applications

                                let params = {
                                    submissionid: aircraftTOO["sub.casa_submissionid"],
                                    srvcatjob: aircraftTOO["srvcatjob.casa_code"],
                                    contactId: aircraftTOO["ind.contactid"],
                                    userId: userdetails.contactId
                                }

                                //populate Aircraft Transfer of Ownership info
                                populateAircraftTOOInfo(aircraftItem, params);
                            }

                        }

                        aircraftArr.push(aircraftItem);
                    }
                }

                for (let l = 0; l < aircraftIndividual.items.gliders.value.length; l++) {
                    let glider = aircraftIndividual.items.gliders.value[l];
                    let user = userdetails.items.value[0];
                    let activeto = moment(glider["participant.casa_validuntil"], 'YYYY-MM-DD').startOf('day');
                    let activefrom = moment(glider["participant.casa_validfrom"], 'YYYY-MM-DD').startOf('day');

                    if ((activeto.isValid() === false || activeto > today)
                        && (activefrom.isValid() === false || activefrom < tomorrow)) {
                        let name = glider["manufacturer.casa_name"] + " " + glider["category.casa_name"];
                        let owner = user["fullname"].toUpperCase() + " " + user["postalAddress"];

                        let gliderItem = {};
                        gliderItem.casa_name = name;
                        gliderItem.owner = owner;
                        gliderItem.casa_validuntil = '';
                        gliderItem.expiry_warning = '';
                        gliderItem.vhmark = glider["aircraft.casa_registrationmark"];
                        gliderItem.serialno = glider["casa_serialnumber"];
                        gliderItem.id = glider["aircraft.casa_aircraftregistrationid"];
                        gliderItem.msgExpiry = '';
                        gliderItem.msgExpiryLevel = '';
                        gliderItem.activeto = "";
                        if (activeto.isValid()) gliderItem.activeto = activeto.format("DD MMM YYYY");

                        gliderArr.push(gliderItem);
                    }
                }
            }

            let showACR = false;
            if (moment(ACRStartDate, "DD/MM/YYYY") <= moment().startOf('day') && moment().endOf('day') <= moment(ACREndDate, "DD/MM/YYYY")) {
                showACR = true;
            }

            //ACR Confirmation exists
            if (appsIndividual.items.census && appsIndividual.items.census.length > 0) {
                showACR = false;
            }

            let crumbs = [
                {
                    link: loc,
                    text: 'myCASA'
                }
            ];
            let crumb = {
                text: 'Manage aircraft',
                link: "/forms/manageaircraftind?standalone=" + standalone
            }
            crumbs.push(crumb);

            let params = {
                'breadcrumbs': crumbs
            }
            let linkConfirm = "/aircraft/confirmation" + "?params=" + encodeURIComponent(btoa(JSON.stringify(params)));

            return (
                <Fragment>
                    <MetaTags>
                        <title>Manage Aircraft (Individual)</title>
                    </MetaTags>

                    <Heading
                        id="manageairindheading"
                        text="Manage aircraft"
                        breadcrumbs={items}
                        showcrumbs={showItems}
                        showback={true} />

                    {showACR && aircraftArr.length > 0 ?
                        <AUcallout title="">
                            <div dangerouslySetInnerHTML={setInnerHTML(snippetARC)}></div>
                        </AUcallout>
                        : null}

                    {showACR && aircraftArr.length > 0 ?
                        <Link
                            id="confirm1"
                            className="au-btn au-btn--secondary"
                            to={linkConfirm}>
                                Confirm aircraft registration details
                        </Link>                       
                        : null}
                   
                    {aircraftArr.length > 0 ?
                        <div className="au-form-group">
                            <SortedTable
                                data={aircraftArr}
                                cols={aircraftCols}
                                caption="Registered aircraft"
                                sortby="vhmark" />
                        </div>
                        : null
                    }

                    {showACR && aircraftArr.length > 0 ?
                         <Link
                            id="confirm2"
                            className="au-btn au-btn--secondary"
                            to={linkConfirm}>
                            Confirm aircraft registration details
                        </Link>                        
                        : null
                    }

                    {gliderArr.length > 0 ?
                        <AUcallout title="">
                            <div dangerouslySetInnerHTML={setInnerHTML(snippetGliderNR)}></div>
                        </AUcallout>
                        : null
                    }

                    {gliderArr.length > 0 ?
                        <div className="au-form-group">
                            <SortedTable
                                data={gliderArr}
                                cols={gliderCols}
                                caption="Registered gliders and motor gliders"
                                sortby="vhmark"
                                cellStyler={styleCellGlider}
                            />
                        </div>
                        : null
                    }

                    <div className="au-form-group">
                        <a className="au-direction-link au-direction-link--left" href={loc}>Return to myCASA</a>
                    </div>
                </Fragment>
            );
        }
    }

}
